{
  "name": "rum-anfitrion",
  "version": "1.0.3",
  "date": "24/09/2025",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.1.7",
    "@angular/common": "^19.1.7",
    "@angular/compiler": "^19.1.7",
    "@angular/core": "^19.1.7",
    "@angular/forms": "^19.1.7",
    "@angular/google-maps": "^19.2.3",
    "@angular/material": "^19.1.5",
    "@angular/platform-browser": "^19.1.7",
    "@angular/platform-browser-dynamic": "^19.1.7",
    "@angular/router": "^19.1.7",
    "@angular/service-worker": "^19.1.7",
    "@ng-bootstrap/ng-bootstrap": "^18.0.0",
    "@popperjs/core": "^2.11.8",
    "angular-calendar": "^0.31.1",
    "bootstrap": "^5.3.3",
    "bootstrap-icons": "^1.11.3",
    "chart.js": "^4.3.0",
    "date-fns": "^4.1.0",
    "ng2-charts": "^8.0.0",
    "ngx-image-cropper": "^9.1.2",
    "ngx-mask": "^19.0.6",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.1",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.1.8",
    "@angular/cli": "^19.1.8",
    "@angular/compiler-cli": "^19.1.7",
    "@angular/localize": "^19.1.7",
    "@types/jasmine": "~5.1.6",
    "jasmine-core": "~5.6.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.7.3"
  }
}